import React from "react";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCartPlus,
} from "@fortawesome/pro-light-svg-icons";

const ListaDeOpcionesDeCanJeOca = ({producto}) => {
  return (
  <>
    <StyledListaDeOpcionesDeCanJeOca>
      {producto.opcionesDeCanjeOca.map((opcionDeCanje, index) => (
        <li key={index}>
          <label>Opcion {index + 1}</label>
          <b>{opcionDeCanje.puntosFormato} Metros</b> +{" "}
          {opcionDeCanje.cantidadDeCuotasMaximas} cuotas de{" "}
          {producto.moneda}
          {opcionDeCanje.precioFinalEnCuotas}
        </li>
      ))}
    </StyledListaDeOpcionesDeCanJeOca>   
  </>
  );
}
const BotonCanjear = styled.a`
      background-color: #006ed2;
      color: white;
      padding: 10px;
      border-radius: ${({theme}) => theme.totalBorderRadius};
      border: thin solid #006ed2;
      display: flex;
      align-items: center;
      justify-content: center;
      text-decoration: none;
      > svg{
        margin-right: 10px;
      }
      &:hover{
        color: #006ed2;
        background-color: white;
      }
`;
const StyledListaDeOpcionesDeCanJeOca = styled.ul`
  display: flex;
  flex-direction: column;
  border: thin solid #006ed2;
  border-radius: ${({theme}) => theme.mediumBorderRadius};
  margin: 20px 10px;
  font-size: 14px;
  > li{
    border-bottom: thin solid #006ed2;
    padding: 12px 6px;
    position: relative;
    > label{
      background-color: #006ed2;
      color: white;
      padding: 3px 6px;
      font-size: 10px;
      border-radius: ${({theme}) => theme.generalBorderRadius};
      position: absolute;
      top: -10px;
      left: -10px;
    }
    > b{
      color: #006ed2;
    }
    &:last-child{
      border-bottom: 0;
    }
  }
`;

export default ListaDeOpcionesDeCanJeOca;